<template>
  <el-card>
    <el-row>
      <el-form v-bind="formProps.form" :model="form">
        <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
          <!--          <v-date-picker ref="datePick" v-model="formTime" />-->
          <range-date-picker :need-init="true" ref="datePick" @showDateTime="(val)=>(formTime=val)" />
        </el-form-item>
        <el-form-item prop="merchatNo" :label="$t('merchantIp.label.merchantNo')">
          <el-input v-model.trim="form.merchatNo"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">
            {{ $t('btns.empty') }}
          </el-button>
          <el-button size="mini" type="primary" @click="handleExport">
            {{ $t('btns.export') }}
          </el-button>
          <el-button size="mini" type="primary" @click="handleSearch">
            {{ $t('btns.search') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table :data="currTableList">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="merchatNo" :label="$t('merchantBalance.label.merchantNo')">
        </el-table-column>
        <el-table-column prop="all" :label="$t('merchantdetails.label.all')">
          <template slot-scope="{ row }">
            {{ (row.all || 0) | toThousands }}
          </template>
        </el-table-column>

        <el-table-column v-for="item in wallettypeList" :key="item" :prop="item"
          :label="$t(`merchantdetails.label.${item}`)">
          <template slot-scope="{ row }">
            {{ (row[item] || 0) | toThousands }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableList.length" />
  </el-card>
</template>

<script>
  import walletAmountApi from '@/api/walletAmount';
  import merchantApi from '@/api/merchant';

  import { debounce } from 'lodash';
  import { chunk } from 'lodash';
  import RangeDatePicker from "../cuscom/range-date-picker.vue";
  export default {
    name: 'merchantAmount',
    components: { RangeDatePicker },
    data() {
      return {
        formTime: [],
        pagination: {
          no: 1,
          size: 100
        },
        form: {},
        tableData: [],

        wallettypes: {
          all: 'all',
          bank_online: 'bank_online',
          bank_qr: 'bank_qr',
          bank_transfer: 'bank_transfer',
          card_pc: 'card_pc',
          card_zing: 'card_zing',
          momo_fix_qr: 'momo_fix_qr',
          momo_qr: 'momo_qr',
          viettel_fix_qr: 'viettel_fix_qr',
          viettel_qr: 'viettel_qr',
          zalo_qr: 'zalo_qr'
        }
      };
    },
    computed: {
      tableTypes() {
        return this.tableData.map((r) => r.channelType);
      },
      wallettypeList() {
        return Object.keys(this.wallettypes).filter((r) => r !== 'all');
      },

      tableList() {
        const arr = this.tableData || [{}];
        const obj = arr.reduce((acc, curr) => {
          if (acc[curr.merchatNo]) {
            acc[curr.merchatNo][curr.channelType] = curr.amount;
            acc[curr.merchatNo]['merchatNo'] = curr.merchatNo;
          } else {
            acc[curr.merchatNo] = {
              [curr.channelType]: curr.amount,
              merchatNo: curr.merchatNo
            };
          }
          return acc;
        }, {});
        // return obj;
        return Object.keys(obj).map((r) => obj[r]);
      },
      chunkTableList() {
        return chunk(this.tableList, this.pagination.size);
      },
      currTableList() {
        return this.chunkTableList[this.pagination.no - 1];
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.getTableList();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this.getTableList, 300);
        this.handleEmpty();
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {}
          }
        };
      },

      handleEmpty() {
        this.form = { merchatNo: '' };
        if (this.$refs.datePick) {
          this.$refs.datePick.handleTime();
        }

      },
      // 钱包类型
      async wallettype() {
        const { data } = await merchantApi.getType();
        if (data) {
          if (data.code === 200) {
            this.wallettypes = data.data;
          } else {
            this.$message.error(data.msg);
          }
        }
      },
      formatParams() {
        const [createTimeStart, createTimeEnd] = this.formTime;

        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            return acc;
          }, {}),
          transactionType: 1,
          createTimeStart,
          createTimeEnd
        };
      },
      async handleExport() {
        const { data } = await walletAmountApi.doExport1(this.formatParams());
        if (data) {
          const BLOB = data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(BLOB);
          fileReader.onload = (event) => {
            // 处理load事件。该事件在读取操作完成时触发
            // 新建个下载的a标签，完成后移除。
            let a = document.createElement('a');
            a.download = `Merchant-Information-${Number(new Date())}.xlsx`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.$message.success(this.$t('status.success'));
          };
        } else {
          this.$message(this.$t('status.error'));
        }
      },
      async getTableList() {
        const { data } = await walletAmountApi.getList(this.formatParams());
        if (data) {
          if (data.code === 200) {
            this.tableData = data.data;
          } else {
            this.$message.error(data.msg);
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/merchant-amount/index.vue